import { View } from "binder"
import { UnitMultiSelectorViewModel } from "../../units/unitMultiSelector";
import { ProductEditorViewModel } from "./productEditor-viewModel"
import { ProductGroupSelectorViewModel } from "../../productGroup/productGroupSelector/productGroupSelector-viewModel";

export class ProductEditorView extends View<ProductEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-1575B037-3D63-4536-8AE8-BAB257292104"
    }
    loadHtml(): string {
        let element = require('./productEditor.html').default;
        let style = require('./productEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set unitSelector(v: UnitMultiSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitMultiSelectorViewModel { return this._unitSelector;} private _unitSelector: UnitMultiSelectorViewModel;
    public set productGroupSelector(v: ProductGroupSelectorViewModel) { this._productGroupSelector = v; } public get productGroupSelector(): ProductGroupSelectorViewModel { return this._productGroupSelector;} private _productGroupSelector: ProductGroupSelectorViewModel;
        
    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
